import React, { useEffect } from 'react';
import { useVideos } from '../../Admin/Videos/VideoStore';
import orn from '../../../assets/images/ornament.svg';
import { Col, Row } from 'react-bootstrap';
import VideoCard from './VideoCard';

function Videos() {
    let { videos, setVideo } = useVideos()
    useEffect(() => {
        setVideo()
    }, [])
    return (
        <>
            <div className="page-intro" style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <h1>Videolar</h1>
            </div>

            <Row>
                {videos.map((item, index) => {
                    return (
                        <Col md={4} key={index}>
                            <VideoCard post={item} />
                        </Col>
                    )
                })}
            </Row>
        </>
    );
}

export default Videos;